export enum PopupAction {
  New = 'New',
  Edit = 'Edit',
  Delete = 'Delete',
  View = 'View'
}
